'use client'

import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import cx from 'classix'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ReactNode } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import { usePricesStore } from '../../../context/PricesProvider'
import type { Price } from '../../../store/pricesStore/pricesStore'
import { SinglePrice } from '../../SinglePrice/SinglePrice'
import styles from '../ExtraInfo.module.css'
import { getTooltipPricesKeys } from './keys'

const lastElement = -1

export type PricesHistoryProps = {
	readonly pricesHistory: Price[]
}

export function PricesHistory({
	pricesHistory,
}: PricesHistoryProps): ReactNode {
	const { channel } = usePricesStore()
	const { t } = useLabels()
	const keysToUse = getTooltipPricesKeys(channel, pricesHistory)

	return (
		<ul className={styles.pricesList}>
			{pricesHistory.map((price, index) => {
				const isCrossedOut =
					pricesHistory.at(lastElement)?.amount !== price.amount
				const labelKey = keysToUse[index]
				const finalPrice = index === pricesHistory.length - 1

				return (
					<li
						className={cx(textBodyS.className, styles.pricesHistory)}
						key={labelKey}
					>
						<span>{t(labelKey)}</span>
						<SinglePrice
							key={labelKey}
							price={price}
							label={labelKey}
							dataTestid='currentPrice'
							isCrossedOut={isCrossedOut}
							priceClassName={cx(
								applyStylesIf(finalPrice, styles.pricesHistoryFinalPrice)
							)}
							withSROnlyAnnotations={false}
							isPricesHistory
						/>
					</li>
				)
			})}
		</ul>
	)
}
